import { render, staticRenderFns } from "./ChartsResumenVoip.vue?vue&type=template&id=876b8668&scoped=true&"
import script from "./ChartsResumenVoip.vue?vue&type=script&lang=js&"
export * from "./ChartsResumenVoip.vue?vue&type=script&lang=js&"
import style0 from "./ChartsResumenVoip.vue?vue&type=style&index=0&id=876b8668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b8668",
  null
  
)

export default component.exports